import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { Project } from '@src/app/models/project';
import { ProjectuserviewService } from './service/projectuserview.service';
import { Task } from '@src/app/models/task';
import { Customer } from './model/customer';
import { Projectperson } from './model/projectperson';
import { UieventhubService } from '@src/app/helpers/uieventhub/uieventhub.service';
import { Subscription } from 'rxjs';
import { DatastoreService } from '@src/app/helpers/datastore/datastore.service';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-projectuserview',
  templateUrl: './projectuserview.component.html',
  styleUrls: ['./projectuserview.component.css']
})
export class ProjectuserviewComponent implements OnInit {
  @Output() assignmentstate:boolean = false;
  projectList:Projectperson[];
  customerList:Customer[];
  taskList:Task[];
  overdueTasks:Task[]; 
  dueTasks:Task[];
  upcomingTasks:Task[];
  doneTasks:Task[];

  @Output() overdueTasksOverview = new EventEmitter<Task[]>(); 
  @Output() dueTasksOverview = new EventEmitter<Task[]>();
  @Output() upcomingTasksOverview = new EventEmitter<Task[]>();
  @Output() doneTasksOverview = new EventEmitter<Task[]>();

  projectsFilterTypeSubscription:Subscription;
  showSpinner:boolean;
  showOnTrack:boolean = true;
  showAlmost:boolean = true;
  showNotOnTrack:boolean = true;

  constructor(
    private puvsrv:ProjectuserviewService, 
    private uieventhub:UieventhubService,
    private datastore:DatastoreService
    ) {
      this.projectsFilterTypeSubscription = this.uieventhub.projectsFilterType$.pipe(untilDestroyed(this)).subscribe(type =>{
        
          if(type == ''){
            this.showAlmost = true;
            this.showNotOnTrack = true;
            this.showOnTrack = true;
          }
          if(type == 'ontrack'){
            this.showAlmost = false;
            this.showNotOnTrack = false;
            this.showOnTrack = true;
            }
          if(type == 'almost'){
            this.showAlmost = true;
            this.showNotOnTrack = false;
            this.showOnTrack = false;
          }
          if(type == 'notontrack'){
            this.showAlmost = false;
            this.showNotOnTrack = true;
            this.showOnTrack = false;
          }
        
      });
    
    
    
    }

  async ngOnInit(): Promise<void> { 
    //this.uieventhub.setShowLoader(true);
    this.overdueTasks = [];
    this.dueTasks = [];
    this.upcomingTasks = [];
    this.doneTasks = [];
    this.customerList = [];

    //Get all projects for user
    // this.getUserProjects()
    // .then((projects)=> this.loopProjects(projects))
    // .then(() => this.emitLists())
    // .then(() => this.doneLoading())
    // .catch((err) => 
    //   console.error('Outer chain failed: ',err)
    // );
    //get all persons projects from datastore
    this.datastore.projectpersonList$.pipe(untilDestroyed(this)).subscribe((projects) => {
      //make projects:Projectperson[] into to Project[]
     //console.log('Projectpersons',projects);
      let plist:Project[] = [];
      for(let p of projects){
        let project = new Project();
        project.projectId = p.projectId;
        plist.push(project);
      }
     //console.log('Project list',plist);
      this.datastore.loadProjectDependentData(plist);
      
    }
    );
    this.datastore.taskList$.pipe(untilDestroyed(this)).subscribe((tasks) => {
     //console.log('Tasks',tasks);
      this.addProjectTasks(tasks);
      this.emitLists();
      this.doneLoading();
    }
    );

    //this.uieventhub.setShowLoader(false);
  }
  doneLoading(){
    setTimeout(() => {
      this.showSpinner = false;
      this.uieventhub.clearLoaders();
    }
    ,100)
    
  }
  emitLists(){
    this.doneTasksOverview.emit(this.doneTasks);
    this.overdueTasksOverview.emit(this.overdueTasks);
    this.upcomingTasksOverview.emit(this.upcomingTasks);
    this.dueTasksOverview.emit(this.dueTasks);
  }
  getUserProjects(){
   return this.puvsrv.getPersonProjects(SessionHelper.getUserSub(),SessionHelper.getChoosenOrg()).toPromise();
  }

  loopProjects(plist:Projectperson[]){
    //console.log('List of person projects',plist);
    this.projectList = plist;
    for(let p of plist){
      if(p.isactive == undefined || p.isactive == true){
        this.getProjectTasks(p)
        .then((projectTasks) => this.addProjectTasks(projectTasks))
        .catch((err) => console.error('inner chain failed: ',err)
        );
      }
      
    }
  }

  getProjectTasks(p:Projectperson){
    return this.puvsrv.getTasks(p.projectId,new Date().toISOString()).toPromise();
  }
  addProjectTasks(tlist:Task[]){
    //console.log('list of tasks',tlist);
    this.doneTasks = [];
    this.overdueTasks = [];
    this.dueTasks = [];
    this.upcomingTasks = [];
    //Loop project tasks
    for(let t of tlist){
      //if task is not done and is mine
      if(t.taskstate != 'Done' && t.responsible == SessionHelper.getUserSub()){
        //If duedate is today
        if(t.duedate.substr(0,10) == new Date().toISOString().substr(0,10) ){
          this.dueTasks.push(t);
        }else{
          //if overdue
          if(t.duedate < new Date().toISOString()){
            this.overdueTasks.push(t);
          }
          //If upcoming
          if(t.duedate > new Date().toISOString()){
            this.upcomingTasks.push(t);

          }
        }
        
      }
      if(t.taskstate == 'Done' && t.responsible == SessionHelper.getUserSub()){
        this.doneTasks.push(t);
      }

      
    }
  }
  // getMembers(projectId:string){
  //   this.puvsrv.getMembers(projectId)
  // }
  
}
